import React, { useState, useEffect, useCallback } from "react";
import Footer from "../../../../components/footer";
// import Invoiceditems from "../../reports/Sales/Invoiceditems";
import { Link, useLocation } from "react-router-dom";
import { IoAdd, IoRemove } from "react-icons/io5";
import Navbar from "../../../../components/header/Navvbar";
import Header from "../../../header/header";
import axios from 'axios';

const Addinvoiceitem = () => {
  const { state } = useLocation();
  const [showParam, setShowParam] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [details, setDetails] = useState([]);
  const [summary, setSummary] = useState({ total: "£0.00" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Get labId and userType from storage
  const getLabIdFromStorage = () => {
    let labId = localStorage.getItem('userLabId') || sessionStorage.getItem('userLabId');
    let userType = localStorage.getItem('userType') || sessionStorage.getItem('userType');
    
    if (!labId || !userType) {
      const userDataStr = localStorage.getItem('userData') || sessionStorage.getItem('userData');
      if (userDataStr) {
        try {
          const userData = JSON.parse(userDataStr);
          if (!labId) labId = userData.labId;
          if (!userType) userType = userData.userType;
        } catch (e) {
          console.error('Error parsing userData:', e);
        }
      }
    }
    
    return { labId, userType: userType || 'admin' };
  };

  const { labId, userType } = getLabIdFromStorage();

  // Get initial filters from navigation state or defaults
  const getInitialFilters = () => {
    if (state?.formData) {
      return {
        startDate: state.formData.startDate,
        endDate: state.formData.endDate,
        selectedAccounts: state.formData.selectedAccounts || [],
        selectedProcedures: state.formData.selectedProcedures || [],
        format: state.formData.format || "On Screen"
      };
    }
    
    // Default to current month
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    
    return {
      startDate: firstDay.toISOString().split('T')[0],
      endDate: lastDay.toISOString().split('T')[0],
      selectedAccounts: [],
      selectedProcedures: [],
      format: "On Screen"
    };
  };

  const [filters, setFilters] = useState(getInitialFilters());

  // Handle filter changes from Invoiceditems component
  const handleFiltersChange = useCallback((newFilters) => {
    setFilters({
      startDate: newFilters.startDate,
      endDate: newFilters.endDate,
      selectedAccounts: newFilters.selectedAccounts || [],
      selectedProcedures: newFilters.selectedProcedures || [],
      format: newFilters.format || "On Screen"
    });
    setShowParam(false);
  }, []);

  /* ---------------- UNITS LOGIC ---------------- */
  const calculateUnits = (procedure) => {
    if (!procedure.unitCount || !procedure.teeth) {
      return procedure.calculatedUnits || "1";
    }

    const teethArray = procedure.teeth
      .split(/,\s*/)
      .filter((t) => t.trim() !== "");

    if (procedure.unitCount === "Count by Unit") {
      const upper = teethArray.filter((t) => t <= "18").length;
      const lower = teethArray.filter((t) => t >= "21").length;
      return Math.max(upper, lower).toString() || "1";
    }

    if (procedure.unitCount === "Count by Teeth") {
      return teethArray.length.toString() || "1";
    }

    return (procedure.calculatedUnits || "1").toString();
  };

  /* ---------------- PRICE LOGIC ---------------- */
  const calculateUnitPrice = (procedure) => {
    const units = parseInt(calculateUnits(procedure)) || 1;
    const totalPrice = procedure.price || 0;
    return totalPrice / units;
  };

  const calculateExtendedPrice = (procedure) => {
    return procedure.price || 0;
  };

  /* ---------------- HELPER FUNCTIONS FOR DATE COMPARISON ---------------- */
  const normalizeToStartOfDay = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const normalizeToEndOfDay = (date) => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
  };

  /* ---------------- FETCH DATA - FIXED VERSION ---------------- */
  const fetchData = useCallback(async () => {
    if (!filters.startDate || !filters.endDate) {
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      let casesData = [];
      let invoicesData = [];

      // STEP 1: Fetch cases based on user type with date filters
      if (userType === 'lab' && labId) {
        // Lab user: Get only their cases with date range
        const casesRes = await axios.get(`https://hms.backend.hiragroupcloud.com/api/cases/lab-cases/${labId}`, {
          params: {
            startDate: filters.startDate,
            endDate: filters.endDate
          }
        });
        casesData = casesRes.data.data || casesRes.data || [];
        console.log('Lab cases data:', casesData.length, 'cases found');
      } else {
        // Admin: Get all cases with date range
        const casesRes = await axios.get("https://hms.backend.hiragroupcloud.com/api/cases/cases", {
          params: {
            startDate: filters.startDate,
            endDate: filters.endDate
          }
        });
        casesData = casesRes.data.data || casesRes.data || [];
        console.log('Admin cases data:', casesData.length, 'cases found');
      }

      // STEP 2: Fetch invoices
      if (userType === 'lab' && labId) {
        const invoicesRes = await axios.get(`https://hms.backend.hiragroupcloud.com/api/invoices/invoices/by-lab/${labId}`);
        invoicesData = invoicesRes.data || [];
      } else {
        const invoicesRes = await axios.get("https://hms.backend.hiragroupcloud.com/api/invoices/invoices/all");
        invoicesData = invoicesRes.data || [];
      }

      console.log('Invoices data:', invoicesData.length, 'invoices found');

      // STEP 3: Create a map for quick invoice lookup
      const invoiceMap = {};
      invoicesData.forEach(inv => {
        if (inv.caseId) invoiceMap[inv.caseId] = inv;
        if (inv.invoiceNumber) invoiceMap[inv.invoiceNumber] = inv;
        // Also map by case_id from cases data
        if (inv.case_id) invoiceMap[inv.case_id] = inv;
      });

      // STEP 4: Filter data
      const from = normalizeToStartOfDay(filters.startDate);
      const to = normalizeToEndOfDay(filters.endDate);

      // Log filter criteria for debugging
      console.log('Filter criteria:', {
        accounts: filters.selectedAccounts,
        procedures: filters.selectedProcedures,
        dateRange: `${filters.startDate} to ${filters.endDate}`
      });

      const filtered = casesData.filter((caseItem) => {
        // Must have invoice number
        if (!caseItem.invoiceNumber) {
          console.log('Case filtered out - no invoice number:', caseItem.case_id);
          return false;
        }

        // Find matching invoice - try multiple matching methods
        const matchingInvoice = invoiceMap[caseItem.invoiceNumber] || 
                               invoiceMap[caseItem.case_id] || 
                               invoiceMap[caseItem._id] ||
                               (caseItem.case_id ? invoiceMap[caseItem.case_id.toString()] : null);
        
        // Date filter - if server already filtered by date, this might be redundant
        // but we keep it as a safety measure
        let isInDateRange = false;
        if (matchingInvoice && matchingInvoice.invoiceDate) {
          const invoiceDate = new Date(matchingInvoice.invoiceDate);
          isInDateRange = invoiceDate >= from && invoiceDate <= to;
        } else if (caseItem.date) {
          const caseDate = new Date(caseItem.date);
          isInDateRange = caseDate >= from && caseDate <= to;
        } else {
          // If no date available, include it (might be from server-side date filtering)
          isInDateRange = true;
        }
        
        if (!isInDateRange) {
          console.log('Case filtered out - date range:', caseItem.invoiceNumber);
          return false;
        }

        // Account filter - FIXED: If no accounts selected, show ALL accounts
        let matchesAccount = true;
        if (filters.selectedAccounts && filters.selectedAccounts.length > 0) {
          const accountName = caseItem.account_name || caseItem.accountName || '';
          matchesAccount = filters.selectedAccounts.some(selectedAccount => 
            accountName.toLowerCase().includes(selectedAccount.toLowerCase())
          );
          if (!matchesAccount) {
            console.log('Case filtered out - account:', caseItem.account_name, 'not in', filters.selectedAccounts);
          }
        }

        // Procedure filter - FIXED: If no procedures selected or "All" is selected, show all
        let matchesProcedure = true;
        if (filters.selectedProcedures && filters.selectedProcedures.length > 0) {
          // Check if "All" is selected
          if (filters.selectedProcedures.includes("All")) {
            matchesProcedure = true;
          } else if (caseItem.procedures && caseItem.procedures.length > 0) {
            matchesProcedure = caseItem.procedures.some((p) => {
              const procName = p.procedure || p.name || '';
              return filters.selectedProcedures.some(selectedProc => 
                procName.toLowerCase().includes(selectedProc.toLowerCase())
              );
            });
          } else {
            // Case has no procedures but procedures are selected
            matchesProcedure = false;
          }
          
          if (!matchesProcedure) {
            console.log('Case filtered out - procedures:', caseItem.invoiceNumber);
          }
        }

        return matchesAccount && matchesProcedure;
      });

      console.log('Filtered cases:', filtered.length, 'out of', casesData.length);

      // STEP 5: Format the data
      const formattedDetails = [];
      let grandTotal = 0;

      filtered.forEach((caseItem) => {
        const matchingInvoice = invoiceMap[caseItem.invoiceNumber] || 
                               invoiceMap[caseItem.case_id] ||
                               invoiceMap[caseItem._id] ||
                               (caseItem.case_id ? invoiceMap[caseItem.case_id.toString()] : null);
        
        const invoiceTotal = matchingInvoice?.total || caseItem.total || 0;
        grandTotal += invoiceTotal;

        // Format invoice date
        let invoiceDate = "";
        if (matchingInvoice && matchingInvoice.invoiceDate) {
          invoiceDate = new Date(matchingInvoice.invoiceDate).toISOString().split('T')[0];
        } else if (caseItem.date) {
          invoiceDate = new Date(caseItem.date).toISOString().split('T')[0];
        } else if (caseItem.invoiceDate) {
          invoiceDate = new Date(caseItem.invoiceDate).toISOString().split('T')[0];
        }

        // Handle cases without procedures
        if (!caseItem.procedures || !caseItem.procedures.length) {
          formattedDetails.push({
            invoice: `${caseItem.invoiceNumber} / ${caseItem.case_id || caseItem._id}`,
            account: caseItem.account_name || caseItem.accountName || "N/A",
            provider: caseItem.provider_name || caseItem.providerName || "N/A",
            patient: `${caseItem.first_name || caseItem.firstName || ""} ${caseItem.last_name || caseItem.lastName || ""}`.trim() || "N/A",
            invoicedate: invoiceDate,
            itemdescription: "N/A",
            longdescription: "No procedures",
            teethnumber: "",
            units: "0",
            unitofmeasure: "Each",
            unitprice: "£0.00",
            extendedprice: "£0.00",
            invoicetotal: `£${invoiceTotal.toFixed(2)}`,
            isLastRow: true,
            rowSpan: 1
          });
          return;
        }

        // Process each procedure
        caseItem.procedures.forEach((procedure, index) => {
          const units = calculateUnits(procedure);
          const unitPrice = calculateUnitPrice(procedure);
          const extendedPrice = calculateExtendedPrice(procedure);

          formattedDetails.push({
            invoice: `${caseItem.invoiceNumber} / ${caseItem.case_id || caseItem._id}`,
            account: caseItem.account_name || caseItem.accountName || "N/A",
            provider: caseItem.provider_name || caseItem.providerName || "N/A",
            patient: `${caseItem.first_name || caseItem.firstName || ""} ${caseItem.last_name || caseItem.lastName || ""}`.trim() || "N/A",
            invoicedate: invoiceDate,
            itemdescription: procedure.procedure || procedure.name || "N/A",
            longdescription: procedure.script || procedure.description || "Procedure+Attributes",
            teethnumber: procedure.teeth || "",
            units,
            unitofmeasure: "Each",
            unitprice: `£${unitPrice.toFixed(2)}`,
            extendedprice: `£${extendedPrice.toFixed(2)}`,
            invoicetotal: index === caseItem.procedures.length - 1 ? `£${invoiceTotal.toFixed(2)}` : "",
            isLastRow: index === caseItem.procedures.length - 1,
            rowSpan: caseItem.procedures.length
          });
        });
      });

      setDetails(formattedDetails);
      setSummary({ total: `£${grandTotal.toFixed(2)}` });
      
      if (formattedDetails.length === 0) {
        setError("No data found for the selected filters. Please try different criteria.");
      } else {
        setError(null);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err.response?.data?.message || err.message || "Failed to fetch data.");
      setDetails([]);
      setSummary({ total: "£0.00" });
    } finally {
      setLoading(false);
    }
  }, [filters, labId, userType]);

  // Fetch data when filters change
  useEffect(() => {
    if (filters.startDate && filters.endDate) {
      fetchData();
    }
  }, [fetchData]);

  /* ---------------- GROUPING ---------------- */
  const groupedDetails = details.reduce((acc, item) => {
    acc[item.invoice] = acc[item.invoice] || [];
    acc[item.invoice].push(item);
    return acc;
  }, {});

  return (
    <>
      <Header />
      <Navbar />
      <br />

      <div style={{ width: "94%" }} className="mx-auto mt-4">
        {/* HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "20px",
            fontWeight: "bold",
            alignItems: "center",
            flexWrap: "wrap"
          }}
        >
          <span>
            Invoiced Items{" "}
            {filters.startDate && filters.endDate && (
              `${new Date(filters.startDate).toLocaleDateString("en-US")} to ${new Date(filters.endDate).toLocaleDateString("en-US")}`
            )}
          </span>

          <div className="col-md-3 d-flex justify-content-end">
            {/* <button
              onClick={() => setShowParam(!showParam)}
              style={{
                backgroundColor: "#004aad",
                color: "white",
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "16px",
                height: "45px",
                border: "none",
                cursor: "pointer"
              }}
            >
              {showParam ? "Hide Parameters" : "Parameters"}
            </button> */}
          </div>
        </div>

        {/* {showParam && (
          <div id="addFile" style={{ marginTop: "20px" }}>
            <Invoiceditems
              initialFilters={filters}
              onFiltersChange={handleFiltersChange}
            />
          </div>
        )} */}

        <br />

        {/* SUMMARY */}
        <h5 style={{ backgroundColor: "white", color: "#004aad", fontWeight: "bold" }}>
          Summary
        </h5>

        <div
          style={{
            backgroundColor: "#f0f0f0",
            borderTop: "3px solid #004aad",
            padding: "20px",
            margin: "10px 0",
          }}
        >
          <div className="d-flex justify-content-between">
            <div style={{ fontWeight: "bold" }}>Total:</div>
            <div>{summary.total}</div>
          </div>
        </div>

        {/* DETAILS */}
        <h5 style={{ fontWeight: "bold", color: "#004aad" }}>Details</h5>

        <div className="border">
          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading data...</p>
            </div>
          ) : error ? (
            <div className="alert alert-danger m-3" role="alert">
              <strong>Error:</strong> {error}
            </div>
          ) : details.length === 0 ? (
            <div className="alert alert-info m-3" role="alert">
              <strong>No results found.</strong> Please adjust your filters and try again.
            </div>
          ) : (
            <table className="table" style={{ fontSize: "15px" }}>
              <thead>
                <tr>
                  {[
                    "Invoice#/ Case#",
                    "Account",
                    "Provider",
                    "Patient",
                    "Invoice Date",
                    "Item Description",
                    "Teeth Number",
                    "Units",
                    "Unit of Measure",
                    "Unit Price",
                    "Extended Price",
                    "Invoice Total",
                  ].map((header, idx) => (
                    <th
                      key={idx}
                      style={{
                        backgroundColor: "#f0f0f0",
                        borderTop: "3px solid #004aad",
                        padding: "20px",
                        height: "85px",
                        cursor: header === "Item Description" ? "pointer" : "default",
                      }}
                      onClick={
                        header === "Item Description"
                          ? () => setIsExpanded(!isExpanded)
                          : undefined
                      }
                    >
                      {header === "Item Description" &&
                        (isExpanded ? <IoRemove /> : <IoAdd />)}{" "}
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {Object.values(groupedDetails).map((group, gIdx) =>
                  group.map((row, rIdx) => {
                    const isFirst = rIdx === 0;
                    const [inv, cs] = row.invoice.split(" / ");

                    return (
                      <tr key={`${gIdx}-${rIdx}`}>
                        {isFirst && (
                          <>
                            <td rowSpan={row.rowSpan}>
                              <Link to={`/invoices/${inv}`} style={{ color: "#004aad" }}>
                                {inv}
                              </Link>{" "}
                              /{" "}
                              <Link to={`/case/${cs}`} style={{ color: "#004aad" }}>
                                {cs}
                              </Link>
                            </td>
                            <td rowSpan={row.rowSpan}>{row.account}</td>
                            <td rowSpan={row.rowSpan}>{row.provider}</td>
                            <td rowSpan={row.rowSpan}>{row.patient}</td>
                            <td rowSpan={row.rowSpan}>{row.invoicedate}</td>
                          </>
                        )}

                        <td>{isExpanded ? row.longdescription : row.itemdescription}</td>
                        <td>{row.teethnumber}</td>
                        <td>{row.units}</td>
                        <td>{row.unitofmeasure}</td>
                        <td>{row.unitprice}</td>
                        <td>{row.extendedprice}</td>
                        <td>{row.isLastRow ? row.invoicetotal : ""}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <br />
      <Footer />
    </>
  );
};

export default Addinvoiceitem;